import { quadrantsENUM } from './config/quadrants';
import { ringsENUM } from './config/rings';

const lastUpdate = new Date('2022-11-28');
export default [
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'spring-boot-for-apis',
    id: 'spring-boot-for-apis',
    title: 'Spring boot for APIs',
    quadrant: quadrantsENUM.LANGUAGES_AND_FRAMEWORKS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Flink-for-stream-processing',
    id: 'Flink-for-stream-processing',
    title: 'Flink for stream processing',
    quadrant: quadrantsENUM.LANGUAGES_AND_FRAMEWORKS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Flutter-for-mobile',
    id: 'Flutter-for-mobile',
    title: 'Flutter for mobile',
    quadrant: quadrantsENUM.LANGUAGES_AND_FRAMEWORKS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Golang-for-event-injestion',
    id: 'Golang-for-event-injestion',
    title: 'Golang for event injestion',
    quadrant: quadrantsENUM.LANGUAGES_AND_FRAMEWORKS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Graphql-for-server-side-resource-aggregation',
    id: 'Graphql-for-server-side-resource-aggregation',
    title: 'Graphql for server side resource aggregation',
    quadrant: quadrantsENUM.LANGUAGES_AND_FRAMEWORKS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.HOLD,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Cloudformation',
    id: 'Cloudformation',
    title: 'Cloudformation (stacker)',
    quadrant: quadrantsENUM.LANGUAGES_AND_FRAMEWORKS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.HOLD,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Express',
    id: 'Express',
    title: 'Express',
    quadrant: quadrantsENUM.LANGUAGES_AND_FRAMEWORKS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.HOLD,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Play-framework-for-APIs',
    id: 'Play-framework-for-APIs',
    title: 'Play framework for APIs',
    quadrant: quadrantsENUM.LANGUAGES_AND_FRAMEWORKS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Spring-Boot-for-stream-processing',
    id: 'Spring-Boot-for-stream-processing',
    title: 'Spring Boot for stream processing',
    quadrant: quadrantsENUM.LANGUAGES_AND_FRAMEWORKS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Scala',
    id: 'Scala',
    title: 'Scala for Spark and Flink jobs',
    quadrant: quadrantsENUM.LANGUAGES_AND_FRAMEWORKS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Kotlin',
    id: 'Kotlin',
    title: 'Kotlin',
    quadrant: quadrantsENUM.LANGUAGES_AND_FRAMEWORKS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Graphql-for-BFF',
    id: 'Graphql-for-BFF',
    title: 'Graphql for BFF',
    quadrant: quadrantsENUM.LANGUAGES_AND_FRAMEWORKS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Terraform',
    id: 'Terraform',
    title: 'Terraform',
    quadrant: quadrantsENUM.LANGUAGES_AND_FRAMEWORKS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.HOLD,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Flask-API',
    id: 'Flask-API',
    title: 'Flask API (python)',
    quadrant: quadrantsENUM.LANGUAGES_AND_FRAMEWORKS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: 'Trial',
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Lambda-functions-with-typescript',
    id: 'Lambda-functions-with-typescript',
    title: 'Lambda functions with typescript',
    quadrant: quadrantsENUM.LANGUAGES_AND_FRAMEWORKS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Spark',
    id: 'Spark',
    title: 'Spark',
    quadrant: quadrantsENUM.LANGUAGES_AND_FRAMEWORKS,
    description: '',
  },
];